<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div
            style="display: flex;justify-content: space-between; align-items: center;"
          >
            <div>
              <span class="mr-3" style="font-size: 16px; color: #99A1B7">{{
                '报工日期:'
              }}</span>
              <el-date-picker
                v-model="localWorkLogTime"
                type="date"
                size="mini"
                style="width: 200px;"
                placeholder="选择报工日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="updateWorkLogTime"
                :disabled="disabled"
              ></el-date-picker>
            </div>

            <b-button
              v-if="!disabled && fillMethoDis"
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-success"
              @click="openChooseGoods()"
              >{{ '添加报工人员' }}
            </b-button>
          </div>

          <!-- <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              :disabled="disabled"
            
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button> -->
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:spec="{ row }">
        <span>{{ row.spec || '' }}</span>
        <span>{{ row.specUnit || '' }}</span>
      </template>
    </vxe-grid>
    <ChooseUser
      :visible.sync="userDialogVisible"
      :title="'报工人员信息'"
      @confirm="userConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import ChooseUser from './choose-user/dialog.vue'
import { cloneDeep } from 'lodash'
export default {
  mixins: [],
  components: { ChooseUser },
  props: {
    disabled: { type: Boolean, default: false },
    fillMethoDis: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    userList: { type: Array, default: () => [] },
    workLogTime: { type: String, default: '' },
  },
  watch: {
    userList: {
      handler() {
        this.tableData = cloneDeep(this.userList || [])
      },
      immediate: true,
    },
    workLogTime: {
      handler(newVal) {
        // 将字符串转换为 Date 对象，如果无效则设为 null
        this.localWorkLogTime = newVal ? new Date(newVal) : null;
        if (this.localWorkLogTime && isNaN(this.localWorkLogTime.getTime())) {
          this.localWorkLogTime = null;
        }
      },
      immediate: true,
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        // {
        //   field: 'checkbox',
        //   width: 40,
        //   align: 'center',
        //   type: 'checkbox',
        //   visible: !this.disabled && this.fillMethoDis,
        // },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 60,
          slots: {
            default: 'opt',
          },
          visible: !this.disabled && this.fillMethoDis,
        },
        {
          title: this.$l('table_label_user_no') || '员工工号',
          field: 'userNo',
          minWidth: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_user_name') || '员工姓名',
          field: 'userName',
          minWidth: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_reportedWorkQty') || '报工数量',
          field: 'reportedWorkQty',
          minWidth: 120,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techChargeUnitText') || '数量单位',
          field: 'techChargeUnitText',
          minWidth: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ]
    },
  },
  data() {
    return {
      tableHeight: 350,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableData: [],
      userDialogVisible: false,
      localWorkLogTime: null, // 初始化为 null
    }
  },
  methods: {
    getTableData() {
      return this.tableData
    },
    openChooseGoods() {
      this.userDialogVisible = true
    },
    userConfirm(data) {
      // if (!data || !data.length) return
      // const tableData = data.filter(
      //   (i) =>
      //     this.tableData.findIndex(
      //       (j) => j.userCode === i.userCode
      //     ) < 0
      // )
      // this.tableData.push(...tableData)
      this.$emit('chooseUserConfirm', data)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.vxeGrid.removeCheckboxRow()
          data.forEach((item) => {
            this.tableData.forEach((row, index) => {
              if (row.userNo === item.userNo) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    //单行删除
    del(row) {
      let index = this.$refs.vxeGrid.getRowIndex(row)
      // this.tableData.splice(index, 1)
      this.$emit('del', index)
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    updateWorkLogTime(value) {
      // value 是 yyyy-MM-dd 格式的字符串或 null
      const stringValue = value || "";
      this.localWorkLogTime = value ? new Date(value) : null;
      this.$emit("update:workLogTime", stringValue);
    },
  },
}
</script>
